module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-22.ba83c1ac.png";